import React from 'react';

const TickerLink = ({
  url = '',
  name = '',
  newtab,
}) => (<a href={url} target={newtab ? '_blank' : '_self'} rel="noreferrer">{name}</a>)

export default TickerLink;
